define(
	'actions/notifications',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
	],
	function($,_,Backbone,React,AppDispatcher,Constants){
		return Backbone.Model.extend({
			pulling: false,
			init: function(params) {
			},
			addNotifications: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATE_NOTIFICATION,
					data: params
				});
			},
			addEntity: function(entityType, params) {
				params.id = params.guid;
				if(entityType === 'buncee') {
					AppDispatcher.dispatch({
						actionType: Constants.CREATED_BUNCEE,
						data: params
					});
				} else if(entityType === 'board') {
					params.id = params.guid;
					AppDispatcher.dispatch({
						actionType: Constants.CREATE_BOARD,
						data: params
					});
				} else if(entityType === 'rsvp') {
					params.id = params.guid;
					AppDispatcher.dispatch({
						actionType: Constants.ADD_RSVP,
						data: params
					});
				} else if(entityType === 'board.pin') {
					params.id = params.guid;
					AppDispatcher.dispatch({
						actionType: Constants.ADD_PIN,
						data: params
					});
				}
			},
			addBoard: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATE_BOARD,
					data: params
				});
			},
			pull: function(onComplete, page) {
				var self = this;
				var notifications = [];
				var params = {}
				if(page) {
					params.page = page;
				}
				if(!this.pulling) {
					this.pulling = true;
					window.api.request("notifications", params).execute().done(function (response) {
						if(response.data) {
							response = response.data;
							self.addNotifications(response.notifications);
							_.each(response.entities, function(entities, index) {
								_.each(entities, function(entity) {
									if(entity) {
										self.addEntity(index, entity);
									}
								});
							});
						}
						if (typeof onComplete === "function") {
							onComplete(response.meta.max_page);
						}
						this.pulling = false;
					});
				}
			},
			markNotificationAsRead: function(params) {
				// debugger;
				AppDispatcher.dispatch({
					actionType: Constants.MARK_NOTIFICATION_READ,
					data: params
				});
			},
			markAsRead: function(guids) {
				var self = this;
				if(guids.length === 0) {
					return;
				}
				if(guids.length === 1) {
					window.api.request("notifications", guids[0], 'read').update({'data' : ''}).done(function() {
						self.markNotificationAsRead({guid: guids[0]});
					});
				} else {
					window.api.request("notifications", 'read').update({'guids' : guids}).done(function() {
						_.each(guids, function(guid) {
							self.markNotificationAsRead({guid: guid});
						});
					});
				}
			}
		});
	}
);
